<template>
  <div>
    <Table
      v-bind="table"
      :initial-rows-limit="previewLimit"
      :load-more="false"
      :disabled-load-more="true"
      v-on="$listeners"
    >
      <template
        v-for="slotName in forwardedSlotNames"
        v-slot:[slotName]="slotProps"
      >
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </Table>

    <Button
      v-if="triggerConfig.show !== false && canExpand"
      class="trigger-button"
      :modifiers="triggerConfig.modifiers"
      :title="triggerConfig.title"
      :on-click="showDialog"
    />

    <Dialog
      v-if="canExpand"
      ref="dialog"
      :title="expandedConfig.title"
      :click-outside="expandedConfig.clickOutside"
    >
      <div v-if="expandedConfig.note" class="dialog-note">
        <Icon :name="expandedConfig.noteIcon" width="20" height="20" />
        <p>{{ expandedConfig.note }}</p>
      </div>

      <Table
        v-bind="table"
        :initial-rows-limit="expandedLimit"
        :load-more="true"
        v-on="$listeners"
      >
        <template
          v-for="slotName in forwardedSlotNames"
          v-slot:[slotName]="slotProps"
        >
          <slot :name="slotName" v-bind="slotProps" />
        </template>
      </Table>
    </Dialog>
  </div>
</template>

<script>
import Dialog from 'Components/02-molecules/dialog/Dialog';
import Button from 'Components/01-atoms/button/Button';
import Table from 'Components/01-atoms/table/Table';
import Icon from 'Components/00-generated/Icon';

const DEFAULT_EXPANDED = {
  enabled: true,
  title: '',
  limit: 10,
  note: '',
  noteIcon: 'info',
  clickOutside: true,
};

export default {
  name: 'ExpandableTableSection',
  components: { Dialog, Button, Table, Icon },
  inheritAttrs: false,
  props: {
    table: { type: Object, required: true },
    preview: { type: Object, default: () => ({}) },
    expanded: {
      type: Object,
      default: () => ({}),
    },
    trigger: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    forwardedSlotNames() {
      return Object.keys(this.$scopedSlots || {});
    },
    triggerConfig() {
      return {
        ...{ modifiers: ['secondary', 'slim'] },
        ...(this.trigger || {}),
      };
    },
    expandedConfig() {
      return {
        ...DEFAULT_EXPANDED,
        ...(this.expanded || {}),
      };
    },
    canExpand() {
      return this.expandedConfig.enabled !== false;
    },
    previewLimit() {
      return typeof this.preview?.limit === 'number' ? this.preview.limit : 4;
    },
    expandedLimit() {
      return typeof this.expandedConfig.limit === 'number'
        ? this.expandedConfig.limit
        : 20;
    },
  },
  methods: {
    showDialog() {
      this.$refs?.dialog?.show?.();
    },
  },
};
</script>

<style scoped lang="scss">
.trigger-button {
  margin-top: var(--space-1);
}

.dialog-note {
  display: flex;
  font-size: var(--font-size-M);
  line-height: var(--space-2--half);
  gap: var(--space-1);
  padding: var(--space-1);
  border-radius: 3px;
  background-color: var(--color-kfzteile24-gray);

  .icon {
    flex: 1 0 auto;
  }
}

::v-deep .match-row {
  background: var(--color-success-green);
}
</style>
